// 从原HTML文件中提取的body内容
// 自动生成，请勿手动修改

const htmlBody = `
    <div class="flex h-full flex-col">
        <!-- Header -->
        <header class="h-16 bg-white border-b border-gray-300 flex items-center justify-between px-6 flex-shrink-0 z-10 shadow-sm">
            <div class="flex items-center gap-4 flex-1 min-w-0">
                                <img 
                    src="/logo.png" id="appLogo" 
                    alt="应用图标" 
                    class="app-logo" 
                    onclick="showLogoModal()"
                    title="点击查看大图"
                >
                <div class="flex-1 min-w-0">
                    <h1 class="font-semibold text-gray-900 leading-tight" style="font-family: 'Comic Sans MS', 'Microsoft YaHei UI', cursive;">无限笔记（Infinite Note）</h1>
                    <p class="text-xs text-gray-600" id="statsText">项目数: 0 | 分组数: 0 | 文本数: 0</p>
                    <p class="text-xs text-gray-500" id="storageInfo" style="display: none;"></p>
                </div>
            </div>
            <div class="flex items-center gap-3 flex-shrink-0">
                <!-- 画布集市按钮 - 活泼可爱的调色盘图标 -->
                <button 
                    id="marketplaceBtn"
                    onclick="window.openMarketplace ? window.openMarketplace() : (window.location.href = '/marketplace')"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%); border-color: #ec4899; color: #db2777;"
                    onmouseover="this.style.transform='scale(1.1) rotate(5deg)'; this.style.boxShadow='0 4px 12px rgba(236, 72, 153, 0.4)';"
                    onmouseout="this.style.transform='scale(1) rotate(0deg)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="画布集市 🎨"
                >
                    <!-- 调色盘图标 - 活泼可爱 -->
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <circle cx="8" cy="9" r="1.5" fill="currentColor"></circle>
                        <circle cx="15" cy="8" r="1.5" fill="currentColor"></circle>
                        <circle cx="16" cy="13" r="1.5" fill="currentColor"></circle>
                        <circle cx="9" cy="14" r="1.5" fill="currentColor"></circle>
                        <path d="M12 17c2 0 3.5-1.5 3.5-3.5 0-1-.5-2-1.5-2.5" stroke-linecap="round"></path>
                    </svg>
                </button>
                <button 
                    onclick="showHelpDialog()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%); border-color: #3b82f6; color: #1e40af;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(59, 130, 246, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="使用说明"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                </button>
                <button 
                    onclick="showSettingsDialog()"
                    class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-md transition-all border-2 shadow-sm font-medium"
                    style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-color: #fbbf24; color: #92400e; font-family: 'STZhongsong', '华文中宋', 'SimSun', serif;"
                    onmouseover="this.style.transform='scale(1.05)'; this.style.boxShadow='0 4px 12px rgba(251, 191, 36, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="设置"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="3"></circle>
                        <path d="M12 1v6m0 6v6M5.64 5.64l4.24 4.24m4.24 4.24l4.24 4.24M1 12h6m6 0h6M5.64 18.36l4.24-4.24m4.24-4.24l4.24-4.24"></path>
                    </svg>
                    设置
                </button>
                <button 
                    onclick="addProject()"
                    class="flex items-center gap-2 px-3 py-1.5 text-sm rounded-md transition-all border-2 shadow-sm font-medium"
                    style="background: linear-gradient(135deg, #c7d2fe 0%, #a5b4fc 100%); border-color: #6366f1; color: #4338ca; font-family: 'STZhongsong', '华文中宋', 'SimSun', serif;"
                    onmouseover="this.style.transform='scale(1.05)'; this.style.boxShadow='0 4px 12px rgba(99, 102, 241, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    新建画布
                </button>
                <button 
                    onclick="pullFromServer()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%); border-color: #10b981; color: #047857;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="从云端下载数据"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                </button>
                <button 
                    onclick="pushToServer()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-color: #f59e0b; color: #92400e;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(245, 158, 11, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="上传到云端保存"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="17 8 12 3 7 8"></polyline>
                        <line x1="12" y1="3" x2="12" y2="15"></line>
                    </svg>
                </button>
                <button 
                    onclick="showAllShareLinksDialog()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%); border-color: #8b5cf6; color: #6d28d9;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(139, 92, 246, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="所有分享链接"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="18" cy="5" r="3"></circle>
                        <circle cx="6" cy="12" r="3"></circle>
                        <circle cx="18" cy="19" r="3"></circle>
                        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                    </svg>
                </button>
                <button 
                    onclick="showUserInfo()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%); border-color: #6366f1; color: #4338ca;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(99, 102, 241, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="用户信息"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </button>
                <button 
                    onclick="event.preventDefault(); event.stopPropagation(); showClearDataDialog(); return false;"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%); border-color: #ef4444; color: #991b1b;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(239, 68, 68, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="清空数据"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                </button>
            </div>
        </header>

        <!-- Projects Tabs -->
        <div class="bg-white border-b border-gray-300 px-6 pt-2 pb-0 flex items-center gap-2 overflow-x-auto custom-scrollbar flex-shrink-0 shadow-sm" id="projectsTabs">
            <!-- 项目标签将动态添加到这里 -->
        </div>

        <!-- Main Content - 无限画布 -->
        <main class="flex-1 overflow-hidden relative" id="canvasContainer">
            <!-- 项目操作按钮组 -->
            <div class="absolute top-4 right-4 z-20 flex items-center gap-2">
                <!-- 新建画布按钮 -->
                <button 
                    id="createCanvasBtn"
                    onclick="window.createNewCanvas && window.createNewCanvas()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-color: #f59e0b; color: #92400e;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(245, 158, 11, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="新建画布"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                </button>
                <!-- 增加文本按钮 -->
                <button 
                    id="addTextBtn"
                    onclick="addTextAtCenter()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    style="background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%); border-color: #3b82f6; color: #1e40af;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(59, 130, 246, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="在画布中心添加文本框"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M4 7h16"></path>
                        <path d="M4 12h16"></path>
                        <path d="M4 17h16"></path>
                    </svg>
                </button>
                <!-- 上传文件或图片按钮 -->
                <button 
                    id="uploadFileBtn"
                    onclick="uploadFileAtCenter()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    style="background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%); border-color: #6366f1; color: #4338ca;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(99, 102, 241, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="在画布中心上传文件或图片"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <path d="M12 18v-6"></path>
                        <polyline points="9 15 12 12 15 15"></polyline>
                    </svg>
                </button>
                <!-- 定位按钮 -->
                <button 
                    id="centerViewBtn"
                    onclick="centerViewOnAllItems()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    style="background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%); border-color: #a855f7; color: #6b21a8;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(168, 85, 247, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="定位到所有元素中心"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <circle cx="12" cy="12" r="3"></circle>
                        <line x1="12" y1="2" x2="12" y2="6"></line>
                        <line x1="12" y1="18" x2="12" y2="22"></line>
                        <line x1="2" y1="12" x2="6" y2="12"></line>
                        <line x1="18" y1="12" x2="22" y2="12"></line>
                    </svg>
                </button>
                <!-- 恢复缩放按钮 -->
                <button 
                    id="resetZoomBtn"
                    onclick="resetZoomToOriginal()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-color: #f59e0b; color: #92400e;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(245, 158, 11, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="恢复原始缩放比（1:1）"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        <path d="M8 12h8"></path>
                        <path d="M12 8v8"></path>
                    </svg>
                </button>
                <!-- 拉取按钮 -->
                <button 
                    id="pullProjectBtn"
                    onclick="pullCurrentProjectFromServer()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%); border-color: #10b981; color: #047857;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="从云端拉取当前项目"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                </button>
                <!-- 推送按钮 -->
                <button 
                    id="pushProjectBtn"
                    onclick="pushCurrentProjectToServer()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-color: #f59e0b; color: #92400e;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(245, 158, 11, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="保存当前项目到云端"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="17 8 12 3 7 8"></polyline>
                        <line x1="12" y1="3" x2="12" y2="15"></line>
                    </svg>
                </button>
                <!-- 分享按钮 -->
                <button 
                    id="shareProjectBtn"
                    onclick="showShareDialog()"
                    class="flex items-center justify-center w-9 h-9 rounded-md transition-all border-2 shadow-sm"
                    style="background: linear-gradient(135deg, #ddd6fe 0%, #c4b5fd 100%); border-color: #8b5cf6; color: #6d28d9;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(139, 92, 246, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="分享画布"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="18" cy="5" r="3"></circle>
                        <circle cx="6" cy="12" r="3"></circle>
                        <circle cx="18" cy="19" r="3"></circle>
                        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                    </svg>
                </button>
                <!-- 清空按钮 -->
                <button 
                    id="clearProjectBtn"
                    onclick="showClearProjectDialog()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    style="background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%); border-color: #ef4444; color: #991b1b;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(239, 68, 68, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="清空当前项目数据"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                </button>
                <!-- 全屏按钮 -->
                <button 
                    id="fullscreenBtn"
                    onclick="toggleFullscreen()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    style="background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%); border-color: #6366f1; color: #4338ca;"
                    onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 4px 12px rgba(99, 102, 241, 0.3)';"
                    onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.1)';"
                    title="全屏显示"
                >
                    <svg id="fullscreenIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
                    </svg>
                </button>
                <!-- 所有东东按钮 -->
                <button 
                    id="objectsListBtn"
                    onclick="toggleObjectsList()"
                    class="p-2 bg-white hover:bg-gray-100 rounded-lg shadow-md border border-gray-300 transition-colors"
                    title="所有东东"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="8" y1="6" x2="21" y2="6"></line>
                        <line x1="8" y1="12" x2="21" y2="12"></line>
                        <line x1="8" y1="18" x2="21" y2="18"></line>
                        <line x1="3" y1="6" x2="3.01" y2="6"></line>
                        <line x1="3" y1="12" x2="3.01" y2="12"></line>
                        <line x1="3" y1="18" x2="3.01" y2="18"></line>
                    </svg>
                </button>
            </div>
            
            <!-- 所有东东侧边栏 -->
            <div id="objectsListPanel" class="absolute top-0 right-0 h-full w-80 bg-white border-l border-gray-300 shadow-xl z-30 transform translate-x-full transition-transform duration-300 overflow-hidden flex flex-col">
                <div class="p-4 border-b border-gray-200">
                    <div class="flex items-center justify-between mb-2">
                        <h2 class="text-lg font-semibold text-gray-900">所有东东</h2>
                        <button 
                            onclick="toggleObjectsList()"
                            class="p-1 hover:bg-gray-100 rounded transition-colors"
                            title="关闭"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                    <!-- 控制菜单 -->
                    <div class="relative">
                        <button 
                            id="objectsListMenuBtn"
                            onclick="toggleObjectsListMenu()"
                            class="w-full flex items-center justify-between px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
                            title="控制菜单"
                        >
                            <span class="flex items-center gap-2">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="3"></circle>
                                    <path d="M12 1v6m0 6v6M5.64 5.64l4.24 4.24m4.24 4.24l4.24 4.24M1 12h6m6 0h6M5.64 18.36l4.24-4.24m4.24-4.24l4.24-4.24"></path>
                                </svg>
                                <span>控制菜单</span>
                            </span>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" id="objectsListMenuArrow">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </button>
                        <!-- 下拉菜单 -->
                        <div id="objectsListMenu" class="hidden absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-40 overflow-hidden">
                            <button 
                                onclick="rearrangeObjects()"
                                class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 transition-colors flex items-center gap-2"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="16 18 22 12 16 6"></polyline>
                                    <polyline points="8 6 2 12 8 18"></polyline>
                                </svg>
                                <span>重新排列</span>
                            </button>
                            <button 
                                onclick="deleteEmptyTexts()"
                                class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 transition-colors flex items-center gap-2"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                                <span>删除空白文本</span>
                            </button>
                            <button 
                                onclick="deleteAllTexts()"
                                class="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                                <span>删除所有文本</span>
                            </button>
                            <button 
                                onclick="deleteAllImages()"
                                class="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                                <span>删除所有图像</span>
                            </button>
                            <button 
                                onclick="deleteAllFiles()"
                                class="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                                <span>删除所有文件</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div id="objectsListContent" class="flex-1 overflow-y-auto custom-scrollbar p-4">
                    <!-- 对象列表将动态添加到这里 -->
                </div>
            </div>
            
            <div class="absolute inset-0 overflow-hidden" id="canvasViewport">
                <div id="canvasContent" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; pointer-events: none; transform-origin: 0 0; overflow: visible;">
                    <!-- 项目元素将绝对定位在这里 -->
                </div>
            </div>
            
            <!-- 缩略图 -->
            <div id="minimap" class="absolute bottom-4 left-4 z-20 bg-white bg-opacity-90 rounded-lg shadow-lg border-2 border-dashed border-gray-400 p-2" style="width: 200px; height: 150px;">
                <canvas id="minimapCanvas" width="184" height="134" class="cursor-pointer"></canvas>
            </div>
        </main>
    </div>

    
`

export { htmlBody }
export default htmlBody
